var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBotB2B(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 625,
    height: 290,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E7",
    d: "M182.972 0h294.237c5.713 0 10.343 4.63 10.343 10.343v174.058H172.629V10.343c0-5.712 4.63-10.343 10.343-10.343Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20244D",
    d: "M621.192 216.383H3.808A3.808 3.808 0 0 0 0 220.191v3.073a3.808 3.808 0 0 0 3.808 3.808h617.384a3.808 3.808 0 0 0 3.808-3.808v-3.073a3.808 3.808 0 0 0-3.808-3.808Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E7",
    d: "M172.629 187.215h314.88v20.989a8.219 8.219 0 0 1-8.222 8.223H180.851a8.219 8.219 0 0 1-8.222-8.223v-20.989Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    d: "M176.395 191.5h307.437v13.805c0 3.765-3.073 6.838-6.838 6.838H183.189c-3.765 0-6.837-3.073-6.837-6.838V191.5h.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E7",
    d: "M613.402 191.5H507.287a3.073 3.073 0 0 0-3.072 3.073v18.782a3.072 3.072 0 0 0 3.072 3.072h106.115a3.072 3.072 0 0 0 3.072-3.072v-18.782a3.072 3.072 0 0 0-3.072-3.073Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    d: "M608.642 195.695h-96.593a2.467 2.467 0 0 0-2.467 2.467v13.07a2.466 2.466 0 0 0 2.467 2.466h96.593a2.467 2.467 0 0 0 2.467-2.466v-13.07a2.468 2.468 0 0 0-2.467-2.467Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A484",
    d: "M519.321 208.982a3.938 3.938 0 1 0 0-7.876 3.938 3.938 0 0 0 0 7.876Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M584.881 202.883h-9.564a2.197 2.197 0 0 0-2.208 2.185c0 1.207.989 2.186 2.208 2.186h9.564a2.197 2.197 0 0 0 2.207-2.186 2.196 2.196 0 0 0-2.207-2.185Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CECECD",
    d: "M508.587 275.975c8.294 0 15.017-.562 15.017-1.255 0-.693-6.723-1.255-15.017-1.255-8.293 0-15.017.562-15.017 1.255 0 .693 6.724 1.255 15.017 1.255Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M545.154 202.883h-9.564a2.196 2.196 0 0 0-2.207 2.185c0 1.207.988 2.186 2.207 2.186h9.564a2.197 2.197 0 0 0 2.207-2.186 2.196 2.196 0 0 0-2.207-2.185Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 1.601,
    d: "M400.871 216.385c107.672 0 70.065 57.687 107.239 57.687 37.175 0 4.674-68.939 31.116-68.939"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#412412",
    d: "M436.918 215.775c-2.77-.65-6.145 0-8.266 1.817-3.505 2.683-7.054-3.202-3.029-5.02 4.068-1.947 8.655-1.861 12.637.173.822.433 1.125 1.428.735 2.207-.389.779-1.298 1.039-2.077.823Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "M434.256 216.747a2.813 2.813 0 0 0 .359-5.614l-1.987-.127a2.813 2.813 0 0 0-.359 5.614l1.987.127Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#412412",
    d: "m431.899 225.729-16.791 2.467c-4.241.476-4.544-5.972-.26-5.843l16.705.087c2.034-.13 2.337 3.073.303 3.289h.043ZM434.67 232.91c-4.198 2.77-9.002 4.285-14.152 3.116-3.765-.908-2.423-6.621 1.342-5.755 3.289 1.601 7.66 1.298 11.079-.174 1.774-.995 3.418 1.732 1.731 2.857v-.044Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "m428.347 224.137-.004-.043a3.203 3.203 0 0 0-3.492-2.884l-2.283.217a3.204 3.204 0 0 0-2.885 3.492l.004.043a3.202 3.202 0 0 0 3.492 2.884l2.283-.217a3.204 3.204 0 0 0 2.885-3.492ZM429.185 236.359a2.813 2.813 0 1 0-.776-5.572l-1.971.274a2.813 2.813 0 1 0 .776 5.572l1.971-.274Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#412412",
    d: "M438.349 236.55c-1.818 4.544-6.665 8.092-11.685 6.664-3.289-.692-2.25-5.669 1.039-5.02 3.029 1.688 6.275-.173 8.093-2.943.865-1.558 3.332-.303 2.553 1.299Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "M431.275 237.673a2.813 2.813 0 0 0 3.826 4.125l1.46-1.354a2.812 2.812 0 1 0-3.826-4.125l-1.46 1.354Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M441.721 210.452c-8.396 3.289-12.551 12.723-9.305 21.119 3.289 8.395 12.723 12.55 21.119 9.304 8.396-3.246 20.08-15.666 16.835-24.062-3.246-8.395-20.254-9.65-28.649-6.361Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#412412",
    d: "M372.567 242.13c1.861 2.164 4.934 3.635 7.79 3.376a2.959 2.959 0 0 1 3.116 2.813c.13 1.947-1.731 3.505-3.592 3.029-4.414-.822-8.136-3.592-10.17-7.573a1.608 1.608 0 0 1 .736-2.208c.779-.389 1.644-.086 2.163.563h-.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "M375.291 242.919a2.813 2.813 0 1 0-3.583 4.337l1.535 1.268a2.812 2.812 0 1 0 3.583-4.337l-1.535-1.268Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#412412",
    d: "m382.477 237.025 15.017 7.876c3.722 2.034.13 7.53-3.246 4.89l-13.502-9.91c-1.731-1.082-.087-3.852 1.688-2.856h.043ZM384.427 229.537c5.02.173 9.824 1.818 13.286 5.756 2.726 3.289-2.64 7.054-4.804 3.376-1.644-3.073-5.496-5.107-8.915-5.886-1.904-.389-1.514-3.376.433-3.289v.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "m384.38 240.382-.022.037a3.202 3.202 0 0 0 1.137 4.384l1.977 1.163a3.204 3.204 0 0 0 4.384-1.137l.022-.037a3.203 3.203 0 0 0-1.137-4.384l-1.977-1.163a3.202 3.202 0 0 0-4.384 1.137ZM390.861 230.003a2.812 2.812 0 1 0-2.638 4.969l1.758.933a2.813 2.813 0 0 0 2.639-4.968l-1.759-.934Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#412412",
    d: "M383.558 224.473c4.154-2.597 10.17-2.64 13.372 1.471 2.251 2.467-1.515 5.929-3.765 3.462-1.471-3.159-5.15-3.549-8.266-2.38-1.601.779-2.856-1.688-1.341-2.553Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "M389.986 227.718a2.814 2.814 0 0 0-.681-5.585l-1.976.241a2.814 2.814 0 0 0 .681 5.585l1.976-.241Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M365.557 243.601c8.742 2.294 17.657-2.942 19.907-11.684 2.294-8.742-2.943-17.657-11.685-19.907-8.741-2.251-25.446.908-27.74 9.607-2.294 8.742 10.776 19.691 19.475 21.941l.043.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "m489.804 158.001 1.428 1.515 7.314-3.073c.995-.433 1.688-1.731 1.644-3.202l-.346-17.527c0-1.472-.779-2.77-1.774-3.116l-7.357-2.77-1.342 1.601c2.294 8.656 2.38 17.527.476 26.615l-.043-.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m466.564 174.878 26.096-12.551c.952-.432 1.688-1.514 2.034-2.899.216-.909.173-1.904 0-2.856-1.428-8.396-1.558-16.792-.346-25.231-.043-2.207-1.039-4.111-2.424-4.673l-25.619-10.387.259 58.597Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M482.276 169.815h3.852a2.557 2.557 0 0 0 2.553-2.553V60.932l-1.558-4.069h-5.842l-1.601 4.068v106.374c.043 1.385 1.211 2.553 2.596 2.553v-.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C67AA",
    d: "m479.634 60.543-.779 13.156 10.82.216-.952-13.329-9.089-.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA86BC",
    d: "m488.721 60.585-1.558-3.765h-5.886l-1.644 3.722 9.088.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#623D90",
    d: "m479.721 80.88 8.958.216.996-7.184-10.82-.217.866 7.184ZM479.68 138.787c2.856-.995 5.885-1.211 9.001 0v-4.154c-2.899-.996-6.102-.952-9.001 0v4.154Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "m324.877 158.001-1.429 1.515-7.313-3.073c-.996-.433-1.688-1.731-1.645-3.202l.346-17.527c0-1.472.779-2.77 1.775-3.116l7.357-2.77 1.341 1.601c-2.293 8.656-2.38 17.527-.476 26.615l.044-.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "m348.159 174.878-26.096-12.551c-.952-.432-1.687-1.514-2.034-2.899-.216-.909-.173-1.904 0-2.856 1.428-8.396 1.558-16.792.347-25.231.043-2.207 1.038-4.111 2.423-4.673l25.62-10.387-.26 58.597Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M332.409 169.815h-3.852a2.557 2.557 0 0 1-2.553-2.553V60.932l1.558-4.069h5.842l1.601 4.068v106.374c-.043 1.385-1.211 2.553-2.596 2.553v-.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C67AA",
    d: "m335.091 60.543.736 13.156-10.776.216.952-13.329 9.088-.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA86BC",
    d: "m326.004 60.585 1.558-3.765h5.842l1.688 3.722-9.088.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#623D90",
    d: "m335.004 80.88-9.001.216-.952-7.184 10.776-.217-.823 7.184ZM335.005 138.787c-2.856-.995-5.885-1.211-9.001 0v-4.154c2.899-.996 6.102-.952 9.001 0v4.154Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CECECD",
    d: "M408.529 289.564c21.989 0 39.815-1.512 39.815-3.376 0-1.864-17.826-3.376-39.815-3.376-21.989 0-39.814 1.512-39.814 3.376 0 1.864 17.825 3.376 39.814 3.376Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M447.046 204.612c-.866-3.592-18.349-6.448-39.771-6.448s-38.992 2.856-39.771 6.448c-2.121 9.478-3.246 17.917-3.246 23.586 0 23.023 19.258 41.675 43.06 41.675 23.802 0 43.06-18.652 43.06-41.675 0-5.669-1.125-14.108-3.289-23.629l-.043.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "M407.275 211.58c21.989 0 39.815-3.003 39.815-6.708s-17.826-6.708-39.815-6.708c-21.989 0-39.814 3.003-39.814 6.708s17.825 6.708 39.814 6.708Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M475.694 111.35c-12.507-25.1-38.387-38.17-68.334-38.17-29.948 0-55.827 13.07-68.334 38.17-1.558 3.072-2.034 6.621-1.385 9.996 1.342 6.968 2.121 15.364 2.121 24.408 0 7.574-.563 14.671-1.515 20.86-.649 4.198.303 8.525 2.9 11.858 13.156 17.31 37.867 24.191 66.213 24.191 28.346 0 53.014-6.881 66.213-24.191 2.553-3.376 3.549-7.704 2.9-11.858-.953-6.189-1.515-13.286-1.515-20.86 0-9.044.779-17.44 2.12-24.408.65-3.375.173-6.924-1.384-9.996Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 1.818,
    d: "M365.688 75.387v37.131M373.781 64.523v60.415M381.918 80.234v30.51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB21C",
    d: "M518.842 185.875h-3.721a.476.476 0 0 0-.476.476v2.9c0 .262.213.476.476.476h3.721a.476.476 0 0 0 .476-.476v-2.9a.476.476 0 0 0-.476-.476Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M540.479 185.875h-3.722a.476.476 0 0 0-.476.476v2.9c0 .262.213.476.476.476h3.722a.476.476 0 0 0 .476-.476v-2.9a.476.476 0 0 0-.476-.476Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A484",
    d: "M515.51 185.875h-3.721a.477.477 0 0 0-.477.476v2.9c0 .262.214.476.477.476h3.721a.476.476 0 0 0 .476-.476v-2.9a.476.476 0 0 0-.476-.476Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E7",
    d: "M510.145 187.219h35.14a.48.48 0 0 1 .476.476v2.077h-36.179v-1.947c0-.303.26-.563.563-.563v-.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    d: "M509.582 188.949h36.179v.822c0 .953-.779 1.732-1.731 1.732h-32.977a1.46 1.46 0 0 1-1.471-1.472V188.949Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ABD1",
    d: "M156.442 216.336h11.728a2.467 2.467 0 0 0 2.467-2.467v-44.055a2.467 2.467 0 0 0-2.467-2.467h-11.728a2.467 2.467 0 0 0-2.467 2.467v44.055a2.467 2.467 0 0 0 2.467 2.467Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00819C",
    d: "M153.975 186.391h16.662v-8.915h-16.662v8.915ZM153.975 208.027h16.662V195.52h-16.662v12.507Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ABD1",
    d: "M63.441 214.437v-6.232a1.947 1.947 0 0 0-1.947-1.947H16.4a1.947 1.947 0 0 0-1.948 1.947v6.232c0 1.076.872 1.948 1.948 1.948h45.094a1.948 1.948 0 0 0 1.947-1.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00819C",
    d: "M53.316 216.385v-10.127h-8.915v10.127h8.915ZM35.227 216.385v-10.127H22.72v10.127h12.507Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D59A4",
    d: "M136.883 216.336h14.367a2.684 2.684 0 0 0 2.684-2.683V170.03a2.684 2.684 0 0 0-2.684-2.683h-14.367a2.684 2.684 0 0 0-2.684 2.683v43.623a2.684 2.684 0 0 0 2.684 2.683Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#414082",
    d: "M134.199 186.391h19.735v-8.915h-19.735v8.915ZM134.199 208.027h19.735V195.52h-19.735v12.507Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D59A4",
    d: "M74.305 204.132v-8.698a2.207 2.207 0 0 0-2.207-2.207H27.523a2.207 2.207 0 0 0-2.207 2.207v8.698c0 1.219.988 2.207 2.207 2.207h44.575a2.207 2.207 0 0 0 2.207-2.207Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#414082",
    d: "M64.18 206.339v-13.112h-8.915v13.112h8.915ZM46.133 206.339v-13.112H33.626v13.112h12.507Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2A322",
    d: "m114.12 214.722 6.327 1.638a1.948 1.948 0 0 0 2.373-1.398l11.298-43.656a1.947 1.947 0 0 0-1.397-2.373l-6.326-1.637a1.948 1.948 0 0 0-2.374 1.397l-11.298 43.656a1.947 1.947 0 0 0 1.397 2.373Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A37415",
    d: "m119.743 185.215 10.097 2.613 2.233-8.63-10.097-2.614-2.233 8.631ZM114.333 206.192l10.097 2.613 3.133-12.108-10.097-2.613-3.133 12.108Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(19.22 -464.458 1536.48) scale(53.9659)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F3F8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D5E6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#A4CAD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-124.88 235.678 35.875) scale(53.9659)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F3F8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D5E6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#A4CAD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(408.53 216.643) scale(63.8762)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F2F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E2EEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#CBE0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#AECFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(406.927 111.696) scale(97.7185)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FDFDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#F6F9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#EAF2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D9E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#C3DCE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#A9CCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 451.597,
    x2: 423.251,
    y1: 143.691,
    y2: 143.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F4F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E7F1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D4E6E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BBD7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#9EC6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 495.259,
    x2: 469.943,
    y1: 67.596,
    y2: 174.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A348B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3B2B71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1836"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 363.22,
    x2: 391.566,
    y1: 143.602,
    y2: 143.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F4F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E7F1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D4E6E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BBD7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#9EC6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 319.469,
    x2: 344.786,
    y1: 67.596,
    y2: 174.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A348B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3B2B71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1836"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h625v289.563H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotB2B);
export default __webpack_public_path__ + "static/media/BotB2B.4f83393d03e35b7edbf127bb86a531bf.svg";
export { ForwardRef as ReactComponent };